import BaseComponent from '/webresources-sources/js/components/base-component';
import { urlQuery } from '/webresources-sources/js/util/url';
import OnDemandLiveRegion from 'on-demand-live-region';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class SwipeComponent extends BaseComponent {
    properties() {
        return {
            targetUrl: undefined,
            currentItem: 0,
            categories: [],
            categoryNames: [],
            selectedCategories: {},
            currentCategoryText: 'Current category',
            finishedSwipingText: 'Selected categories',
        };
    }

    connected() {
        this.categories = Array.from(this.element.querySelectorAll('[data-category]')).map((category) =>
            category.getAttribute('data-category'),
        );
        this.categoryNames = Array.from(this.element.querySelectorAll('[data-category-name]')).map((category) =>
            category.getAttribute('data-category-name'),
        );
        this.initCategories();

        this._liveRegion = new OnDemandLiveRegion({
            level: 'polite',
            delay: 250,
        });
    }

    afterUpdate() {
        const actionButtonNo = this.element.querySelector('[data-action="no"]');
        const actionButtonYes = this.element.querySelector('[data-action="yes"]');
        actionButtonNo.setAttribute(
            'aria-label',
            `${actionButtonNo.getAttribute('data-aria-label')}: ${this.categoryNames[this.currentItem]}`,
        );
        actionButtonYes.setAttribute(
            'aria-label',
            `${actionButtonYes.getAttribute('data-aria-label')}: ${this.categoryNames[this.currentItem]}`,
        );
    }

    watch() {
        return {
            currentItem: (currentItem) => {
                if (currentItem !== this.categories.length) {
                    this._liveRegion.say(`${this.currentCategoryText}: ${this.categoryNames[this.currentItem]}`);
                }

                if (currentItem === this.categories.length) {
                    this.element.classList.add('is-done');

                    this._liveRegion.say(`${this.finishedSwipingText}: ${this.categoryNames.join(',')}`);
                }
                if (this.targetUrl) {
                    this.updateTarget();
                } else {
                    this.updateUrl();
                }
            },
        };
    }

    events() {
        return {
            this: {
                'slick-carousel-init': (e) => {
                    this._slick = e.detail.slick;
                },
            },
            '[data-action]': {
                click: (e) => {
                    if (!this._slick) {
                        // due to race conditions slick-carousel-init might have been dispatched before we added the listener for it...
                        const slickInitialized = this.element.querySelector('.slick-initialized');
                        this._slick = slickInitialized?._component?._slick;
                    }

                    const action = e.target.closest('[data-action]').getAttribute('data-action');

                    if (action === 'back') {
                        if (this.currentItem === 0) {
                            return;
                        }

                        this.selectedCategories[this.categories[this.currentItem]] = false;
                        this.currentItem--;
                        this._slick.slickPrev();
                    }

                    if (action === 'no' || action === 'yes') {
                        if (this.currentItem === this.categories.length) {
                            return;
                        }

                        this.selectedCategories[this.categories[this.currentItem]] = action === 'yes';
                        this.currentItem++;

                        if (this.currentItem < this.categories.length) {
                            this._slick.slickNext();
                        }
                    }

                    if (action === 'reverse') {
                        this.initCategories();
                        this.currentItem = 0;
                        this.element.classList.remove('is-done');
                        this._slick.slickGoTo(0);
                    }

                    e.target.closest('button').classList.add('hover');
                    setTimeout(() => {
                        e.target.closest('button').classList.remove('hover');
                    }, 250);
                },
            },
        };
    }

    get filteredCategories() {
        const filteredCategories = [];

        this.categories.forEach((category) => {
            if (this.selectedCategories[category] === true) {
                filteredCategories.push(category);
            }
        });

        return filteredCategories;
    }

    initCategories() {
        const categories = {};
        this.categories.forEach((category) => {
            categories[category] = false;
        });
        this.selectedCategories = categories;
    }

    get urlParameters() {
        return {
            /*'regions': this.filteredCategories['regions'],*/
            categories: this.filteredCategories?.length > 0 ? this.filteredCategories : undefined,
            /*page: this.page,*/
        };
    }

    updateUrl() {
        history.replaceState(this.urlParameters, '', `?${urlQuery(this.urlParameters, true)}`);
        window.dispatchEvent(new Event('locationchange'));
    }

    updateTarget() {
        const targetLink = this.element.querySelector('[data-target]');
        targetLink.href = `${this.targetUrl}?${urlQuery(this.urlParameters, true)}#pages-overview-component`;
    }
}

defineComponent('swipe-component', SwipeComponent);
